// Mandarin Chinese (Simplified) — top-level translations.
import en from "./en";

const zh = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "涂色与学习",
    nav: {
      home: "首页", countries: "国家", globe: "地球", continents: "大洲",
      color: "涂色", puzzles: "拼图", games: "游戏", math: "地理数学",
      quiz: "测验", parents: "家长", more: "更多",
     "geo-lines": "世界经纬线", "maths-academy": "数学学院",},
    accessibility: { bigText: "大字体", highContrast: "高对比度" },
    navGroups: { quick: "快捷", explore: "探索", play: "玩转学习", collect: "收集", adv: "冒险", grownup: "家长专区" },
    actions: { back: "返回", close: "关闭", reset: "重置", save: "保存", retry: "再试一次", playAgain: "再玩一次" },
  },
  microcopy: {
    ...en.microcopy,
    great: "做得好! ⭐",
    correct: "✅ 正确！",
    nope: "再试一次!",
    tryAgain: "差一点。继续加油！",
    awesome: "太棒了！",
    welcome: "欢迎来到{{country}}！让我们学习{{language}}。",
    youDidIt: "你做到了！",
    perfect: "完美！",
  },
  home: {
    ...en.home,
    title1: "探索世界",
    title2: "一次一个国家",
    subtitle: "有趣的地理冒险、测验、挑战和奖励，帮助孩子们发现国家、文化、旗帜、地标等等。",
    playNow: "开始玩 →",
    takeQuiz: "做测验",
    openGlobe: "打开大地球 →",
    globeHint: "点击发光的标记学习一个国家！",
    popularCountries: "或者点击国旗",
    whatNext: "今天想做什么？",
    whatNextSub: "随便选一个，都很好玩！",
    tiles: {
      ...en.home.tiles,
      learn: "学习国家", learnDesc: "30多个国家和国旗！",
      globe: "3D地球", globeDesc: "旋转点击去探索",
      continents: "大洲", continentsDesc: "探索七大洲",
      color: "涂色名胜", colorDesc: "给埃菲尔铁塔涂色！",
      math: "地理数学", mathDesc: "加公里，数国家！",
      quiz: "测验时间", quizDesc: "基础和高级测验",
      parents: "家长", parentsDesc: "查看孩子的进度",
    },
  },
  learn: {
    title: "学习国家", capital: "首都", language: "语言", hello: "你好",
    learnIt: "我学会了！", listen: "听一听",
    goalsEyebrow: "今日学习目标",
    goalsHeading: "🎯 先从这些开始",
    goalsSubtitle: "{{tier}}岁必须掌握的四件最重要的事——按课程精选。",
    goalsAllTopics: "查看所有主题",
    goalsLearnNow: "立即学习",
    goalsKey: "重点 #{{n}}",
    topicTitles: {
      "art-design": "绘画、涂色与设计",
      "music": "音乐：节奏、歌唱与乐谱",
      "computing-code": "编程、算法与网络安全",
      "physical-education": "体育、健康与运动",
      "world-religions": "世界宗教与信仰",
      "wellbeing-relationships": "健康、情绪与友谊",
    },
  },
  globe: {
    title: "3D地球", subtitle: "旋转点击去探索",
    learnLang: "学习语言", moreInfo: "更多信息", learnedTag: "✓ 已学习",
    spinTap: "转动地球，点击一个国家！", spinTapSub: "点击标记了解更多。",
  },
  quiz: {
    title: "测验", basic: "基础", advanced: "高级",
    start: "开始测验", next: "下一题 →", finish: "完成！", score: "得分",
  },
  stickers: { title: "我的贴纸册", subtitle: "从每个活动收集一张贴纸！" },
  langSwitcher: {
    label: "语言",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "接下来去哪里？",
    home: "首页",
    earnMoreStars: "⭐ 赢取更多星星",
    earnHowTo: "玩一个快速游戏 — 每个都给你 XP！",
    pickAge: "选择年龄",
    ages: "年龄",
    startExploring: "开始探索",
    pickAnywhere: "从上方选择 — 或点击这里！",
    tapAnyCountry: "点击任意国家，了解它的故事！",
    exploreGlobe: "探索地球",
    exploreGlobeSub: "全屏 3D 冒险",
  },
  shortcuts: {
    home: "主页",
    continents: "大陆",
    globe: "地球",
    ask: "提问",
    landmarks: "地标",
    flags: "国旗",
    pixel: "像素",
    puzzles: "拼图",
    math: "数学",
    trip: "旅行",
    quiz: "测验",
    quests: "任务",
    stickers: "贴纸",
    miniGames: "小游戏",
    geoMath: "地理数学",
    quickQuiz: "快速测验",
    myTrophies: "我的奖杯",
    colorCreate: "涂色与创作",
    spinGlobe: "旋转地球",
    askGlobe: "问问地球",
    dreamTrip: "梦想之旅",
    earnStars: "赚取星星",
    tryAQuest: "尝试任务",
    playAgain: "再玩一次",
    learnCountry: "学习一个国家",
    colorLandmark: "为地标涂色",
    learnCountries: "学习国家",
    advanced: "高级模式",
    spellCountry: "拼写一个国家",
    advancedHub: "高阶专区",
    squishyHop: "弹跳挑战",
    mathSnap: "数学卡牌",
    language: "语言",
    geoLines: "世界经纬线",
  },
  coloringExtra: {
    modeLandmarks: "地标",
    modeFlags: "国旗艺术家",
    modePixel: "像素艺术",
    diffEasy: "简单",
    diffMedium: "中等",
    diffExpert: "专家",
    difficultyLabel: "难度：",
  },
  tilesExtra: {
    labelLearn: "学习",
    labelCreate: "创作",
    labelPlay: "游戏",
    labelTrophies: "奖杯",
    whatNextSub: "随便选 — 都很好玩！",
  },
  pills: {
    orTry: "或试试 ↓",
    
    squishyHop: "果冻跳跳",
    mathSnap: "数学闪卡",colorLandmark: "给地标涂色",
    solvePuzzle: "解决一个拼图",
    dreamTrip: "规划梦想之旅",
    geoMath: "试试地理数学",
    continentQuests: "大陆任务",
    stickerBook: "贴纸册",
    famousPeople: "认识名人",
    culturalSpot: "文化亮点",
    quickQuiz: "快速测验",
    continentMaps: "大陆地图",
    spellCountry: "拼写一个国家",
    flagArtist: "国旗艺术家",
    pixelArt: "像素艺术",
    spinGlobe: "旋转地球",
    askGlobe: "问问地球",
    myTrophies: "我的奖杯",
    advancedHub: "高阶专区",
    geoLines: "世界经纬线",
  },
  canvas: {
    tools: "工具",
    brushSize: "笔刷大小",
    colors: "颜色",
    patterns: "图案",
    modes: "模式",
    solid: "纯色",
    anyColor: "任何颜色",
    recent: "最近",
    sticker: "贴纸",
    symmetry: "对称",
    colorByNumber: "按数字涂色",
    reference: "参考",
    undo: "撤销",
    redo: "重做",
    reset: "重置",
    replay: "回放",
    check: "检查",
    save: "保存",
    fill: "填充",
    pencil: "铅笔",
    stamp: "印章",
    erase: "擦除",
    on: "开",
    off: "关",
    tool: "工具：",
    pattern: "图案：",
    printOne: "打印这个",
    downloadAll: "全部下载",
    appTitle: "涂色与创作 🎨",
    appSub: "笔刷、图案、贴纸、按数字涂色等等！",
  },
};

export default zh;
